import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from 'react-icons/fi';
import { InlineSpinner } from '../UI/ComponnentsUI/common/LoadingSpinner';
import { Button } from '../UI/ComponnentsUI/common/Button';
import { GuideRenderer } from './GuideRenderer';
import { useGuideContent } from './useGuideContent';

interface GuideBodyProps {
  guideId: string;
  onNavigateGuide: (id: string) => void;
}

/** Loading, error and rendered states for one guide. */
export const GuideBody: React.FC<GuideBodyProps> = ({
  guideId,
  onNavigateGuide,
}) => {
  const { t } = useTranslation('HelpGuide');
  const { status, markdown, retry } = useGuideContent(guideId);

  if (status === 'loading' || status === 'idle')
    return <InlineSpinner label={t('content.loading')} />;

  if (status === 'error') {
    return (
      <div
        role="alert"
        className="flex flex-col items-center gap-3 rounded-lg border border-red-200 bg-red-50 p-6 text-center dark:border-red-800 dark:bg-red-900/20"
      >
        <FiAlertTriangle className="text-2xl text-red-500" aria-hidden="true" />
        <p className="text-sm text-red-700 dark:text-red-300">
          {t('content.error')}
        </p>
        <Button variant="outline" size="sm" onClick={retry}>
          {t('content.retry')}
        </Button>
      </div>
    );
  }

  return (
    <GuideRenderer markdown={markdown} onNavigateGuide={onNavigateGuide} />
  );
};
